import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { UserStateModel } from '../../../../Core/Users/models/user-state.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { G2Api } from '../../../../api/g2/g2.api';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';

@Component({
    selector: 'agpr-g2-review-dialog',
    templateUrl: 'g2-review-dialog.component.html',
    styleUrls: ['g2-review-dialog.component.scss'],
    standalone: false
})
export class G2ReviewDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {

    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    public onetimePasscode: string;
    public user: UserStateModel;
    public url: string = null;

    public readonly buttonTypesEnum = ButtonTypesEnum;

    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        public currentUserStateService: CurrentUserStateService,
        public g2Api: G2Api
    ) {
        super(coreDialogService, 'G2ReviewDialogComponent');

        this.subscriptions.push(
            this.currentUserStateService.getState().subscribe(state => {
                this.user = state;
                this.makeUrl();
            }),
            this.g2Api.getOneTimeToken().subscribe(passcode => {
                this.onetimePasscode = passcode.state;
                this.makeUrl();
            })
        );
    }

    private makeUrl() {
        if (this.onetimePasscode && this.user) {
            this.url = `https://www.g2.com/partnerships/AgilityPRSolutions/users/login.embed?state=${this.onetimePasscode}&email=${this.user.user.email}`;
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    cancel() {
        this.closeDialog();
    }
}
